import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { login, updateTitle, forgotPassword, register } from './../../actions'
import TextField from 'material-ui/TextField'
import RaisedButton from 'material-ui/RaisedButton'

class AppLoginFormContainer extends Component {
  state = {
    showProgressLogin: false,
    showProgressRegister: false,
    errorMessageLogin: null,
    errorMessageRegister: null,
    errorMessageForgotPassword: null,
    tab: 'login'
  }

  constructor(props) {
    super(props)
    this.username = null
    this.password = null

    this.nameRegister = null
    this.usernameRegister = null
    this.passwordRegister = null
    this.repeatedPasswordRegister = null
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user !== null) hashHistory.push('profile')
  }

  handleForgotPassword() {
    this.setState({
      errorMessageForgotPassword: null
    })

    if (this.username.input.value.length < 3) {
      this.setState({
        errorMessageForgotPassword: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (this.username.input.value === undefined) {
      this.setState({
        errorMessageForgotPassword: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.username.input.value
      ) === false
    ) {
      this.setState({
        errorMessageForgotPassword: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (this.state.errorMessageForgotPassword !== null) return

    this.props.actions.forgotPassword(
      {
        username: this.username.input.value
      },
      () => {
        this.setState({
          tab: 'forgot'
        })
      }
    )
  }

  handleLogin() {
    this.setState({
      errorMessageLogin: null,
      showProgressLogin: false
    })

    if (this.username.input.value.length < 3) {
      this.setState({
        errorMessageLogin: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (this.username.input.value === undefined) {
      this.setState({
        errorMessageLogin: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.username.input.value
      ) === false
    ) {
      this.setState({
        errorMessageLogin: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (this.password.input.value.length < 3) {
      this.setState({
        errorMessageLogin: 'Debes ingresar una contraseña.'
      })
      return
    }

    if (this.password.input.value === undefined) {
      this.setState({
        errorMessageLogin: 'Debes ingresar una contraseña.'
      })
      return
    }

    if (this.state.errorMessageLogin !== null) return

    this.setState({
      showProgressLogin: true
    })

    this.props.actions.login(
      {
        username: this.username.input.value,
        password: this.password.input.value
      },
      () => {
        this.setState({
          showProgressLogin: false
        })
      }
    )
  }

  handleRegister() {
    this.setState({
      errorMessageRegister: null,
      showProgressRegister: false
    })

    if (this.nameRegister.input.value.length < 3) {
      this.setState({
        errorMessageRegister: 'Debes ingresar tu nombre.'
      })
      return
    }

    if (this.nameRegister.input.value === undefined) {
      this.setState({
        errorMessageRegister: 'Debes ingresar tu nombre.'
      })
      return
    }

    if (this.usernameRegister.input.value.length < 3) {
      this.setState({
        errorMessageRegister: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (this.usernameRegister.input.value === undefined) {
      this.setState({
        errorMessageRegister: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.usernameRegister.input.value
      ) === false
    ) {
      this.setState({
        errorMessageRegister: 'Debes ingresar un correo electrónico.'
      })
      return
    }

    if (this.passwordRegister.input.value.length < 3) {
      this.setState({
        errorMessageRegister: 'Debes ingresar una contraseña.'
      })
      return
    }

    if (this.repeatedPasswordRegister.input.value === undefined) {
      this.setState({
        errorMessageRegister: 'Debes ingresar una contraseña.'
      })
      return
    }

    if (this.repeatedPasswordRegister.input.value.length < 3) {
      this.setState({
        errorMessageRegister: 'Debes ingresar la contraseña repetida.'
      })
      return
    }

    if (this.repeatedPasswordRegister.input.value === undefined) {
      this.setState({
        errorMessageRegister: 'Debes ingresar la contraseña repetida.'
      })
      return
    }

    if (
      this.repeatedPasswordRegister.input.value !==
      this.passwordRegister.input.value
    ) {
      this.setState({
        errorMessageRegister:
          'La contraseña del registro y la repetición no coinciden.'
      })
      return
    }

    if (this.state.errorMessageRegister !== null) return

    this.setState({
      showProgressRegister: true
    })

    this.props.actions.register(
      {
        name: this.nameRegister.input.value,
        username: this.usernameRegister.input.value,
        password: this.passwordRegister.input.value
      },
      () => {
        this.setState({
          showProgressRegister: false
        })
      }
    )
  }

  render() {
    const forgot = (
      <div>
        <h3>Olvidé mi contraseña</h3>
        <p>
          Para cambiar tu contraseña escribe tu email, presiona recuperar mi
          contraseña y luego revisa tu email.
        </p>
        {this.props.success.forgot !== null &&
          <h3 className="success">
            {this.props.success.forgot}
          </h3>}
        {this.props.error.forgot !== null &&
          <h3 className="error">
            {this.props.error.forgot}
          </h3>}
        <form className="content">
          <TextField
            tabIndex={1}
            ref={input => (this.username = input)}
            id="username"
            fullWidth={true}
            floatingLabelText="Correo electrónico"
            errorText={this.state.errorMessageForgotPassword}
          />
          <br />
          <br />
          <br />
          <RaisedButton
            tabIndex={3}
            className="full right"
            label={'recuperar contraseña'}
            secondary={true}
            onTouchTap={() => {
              this.handleForgotPassword()
            }}
          />
        </form>
      </div>
    )

    const login = (
      <div>
        <h3>Iniciar sesión</h3>
        <p>
          Si ya tienes una cuenta en Ebooks Patagonia ingresa tu correo
          electrónico, contraseña y luego apreta el botón Ingresar.
        </p>
        {this.props.success.login !== null &&
          <h3 className="success">
            {this.props.success.login}
          </h3>}
        {this.props.error.login !== null &&
          <h3 className="error">
            {this.props.error.login}
          </h3>}
        <form className="content">
          <TextField
            tabIndex={1}
            ref={input => (this.username = input)}
            id="username"
            fullWidth={true}
            floatingLabelText="Correo electrónico"
            errorText={this.state.errorMessageLogin}
          />
          <TextField
            tabIndex={2}
            ref={input => (this.password = input)}
            type={'password'}
            id="password"
            fullWidth={true}
            floatingLabelText="Contraseña"
          />
          <br />
          <br />
          <br />
          <RaisedButton
            tabIndex={3}
            className="full right"
            disabled={
              this.state.showProgressLogin && this.props.isLoggedIn === false
            }
            label={
              this.state.showProgressLogin && this.props.isLoggedIn === false
                ? 'Cargando ...'
                : 'Ingresar'
            }
            secondary={true}
            onTouchTap={() => {
              this.handleLogin()
            }}
          />
          <br />
          <br />
          <p className="center">
            ¿No tienes cuenta? Regístrate{' '}
            <span
              className="link"
              onTouchTap={() => {
                this.setState({
                  tab: 'register'
                })

                this.props.actions.updateTitle({
                  label: 'Ebooks Patagonia',
                  back: null,
                  action: () => {}
                })
              }}
            >
              aquí
            </span>, si olvidaste tu contraseña haz click{' '}
            <span
              className="link"
              onTouchTap={() => {
                this.setState({
                  tab: 'forgot'
                })

                this.props.actions.updateTitle({
                  label: 'Volver',
                  back: true,
                  action: () => {
                    this.setState({
                      tab: 'login'
                    })

                    this.props.actions.updateTitle({
                      label: 'Ebooks Patagonia',
                      back: null,
                      action: () => {}
                    })
                  }
                })
              }}
            >
              aquí
            </span>.
          </p>
        </form>
      </div>
    )

    const register = (
      <div>
        <h3>Registrame</h3>
        <p>
          Si no tienes cuenta en Ebooks Patagonia ingresa tu correo electrónico,
          contraseña y luego apreta el botón Registrame.
        </p>
        {this.props.success.register !== null &&
          <h3 className="success">
            {this.props.success.register}
          </h3>}
        {this.props.error.register !== null &&
          <h3 className="error">
            {this.props.error.register}
          </h3>}
        <form className="content">
          <TextField
            tabIndex={5}
            ref={input => (this.nameRegister = input)}
            id="name"
            fullWidth={true}
            floatingLabelText="Nombre y apellido"
            errorText={this.state.errorMessageRegister}
          />
          <TextField
            tabIndex={5}
            ref={input => (this.usernameRegister = input)}
            id="username"
            fullWidth={true}
            floatingLabelText="Correo electrónico"
          />
          <TextField
            tabIndex={6}
            ref={input => (this.passwordRegister = input)}
            type={'password'}
            id="password"
            fullWidth={true}
            floatingLabelText="Contraseña"
          />
          <TextField
            tabIndex={7}
            ref={input => (this.repeatedPasswordRegister = input)}
            type={'password'}
            id="password"
            fullWidth={true}
            floatingLabelText="Repetir contraseña"
          />
          <br />
          <br />
          <br />
          <RaisedButton
            tabIndex={8}
            className="full right"
            label={'Registrarme'}
            secondary={true}
            onTouchTap={() => {
              this.handleRegister()
            }}
          />
          <br />
          <br />
          <p className="center">
            ¿Ya tienes cuenta? Ingresa{' '}
            <span
              className="link"
              onTouchTap={() => {
                this.setState({
                  tab: 'login'
                })

                this.props.actions.updateTitle({
                  label: 'Ebooks Patagonia',
                  back: null,
                  action: () => {}
                })
              }}
            >
              aquí
            </span>
          </p>
        </form>
      </div>
    )

    return (
      <div className="container">
        {this.state.tab === 'login' &&
          <div>
            {login}
          </div>}
        {this.state.tab === 'register' &&
          <div>
            {register}
          </div>}
        {this.state.tab === 'forgot' &&
          <div>
            {forgot}
          </div>}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
    error: state.error,
    success: state.success
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { login, register, updateTitle, forgotPassword },
      dispatch
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  AppLoginFormContainer
)



// WEBPACK FOOTER //
// ./src/components/App/AppLoginFormContainer.js